import { render, staticRenderFns } from "./FlightNumber.vue?vue&type=template&id=aefa6a66&scoped=true&"
import script from "./FlightNumber.vue?vue&type=script&lang=js&"
export * from "./FlightNumber.vue?vue&type=script&lang=js&"
import style0 from "./FlightNumber.vue?vue&type=style&index=0&id=aefa6a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefa6a66",
  null
  
)

export default component.exports